<template>
  <el-dialog
    title="请选择："
    width="800px"
    :visible.sync="visible"
    append-to-body
    :close-on-click-modal="false"
    class="ds-custom-drop-tree_chooseDialog"
  >
    <div
      class="main"
      :class="{ noConst: noConst, noData: !(loading || data.length || keyWord) }"
    >
      <div class="left">
        <div class="input-box">
          <div class="head">自定义：</div>
          <el-input
            resize="none"
            type="textarea"
            placeholder="输入自定义数据"
            :rows="2"
            v-model="inputValue"
          >
          </el-input>
        </div>
        <div class="head">
          <el-checkbox
            :indeterminate="checkConfig.isIndeterminate"
            v-model="checkConfig.checkAll"
            @change="checkAll"
            :disabled="data.length == 0"
          >
            {{ loading || data.length || keyWord ? "常量：" : "暂无常量" }}
          </el-checkbox>
        </div>
        <el-input
          v-if="loading || data.length || keyWord"
          clearable
          placeholder="输入关键字"
          class="searchBox"
          v-model="keyWord"
        >
          <template slot="suffix">
            <i class="el-icon-search" title="搜索"></i>
          </template>
        </el-input>
        <div class="list" v-if="loading || data.length || keyWord">
          <dsf-virtual-scroll scroll-x @scroll="paginationScroll">
            <div
              v-loading="loading"
              element-loading-text="数据加载中"
              element-loading-spinner="el-icon-loading"
            >
              <el-checkbox-group
                v-model="checkConfig.constChoose"
                @change="changeState"
              >
                <el-checkbox
                  v-for="item in data"
                  :label="item.index"
                  :key="item.id"
                  :disabled="item.choosed"
                >
                  {{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </dsf-virtual-scroll>
        </div>
      </div>
      <div class="center">
        <DsfButton @click="chooseFn">选择 ></DsfButton>
      </div>
      <div class="right">
        <div class="head el-row">
          <div class="ellipsis el-col el-col-12">
            已选择
            <b
              class="chooseNum"
              :class="{ over: maxLength ? value.length > maxLength : false }"
            >
              {{ value.length || 0 }}{{ maxLength ? "/" + maxLength : "" }}
            </b>
          </div>
          <div class="ellipsis el-col el-col-12">
            <span @click="resetFn">
              <i class="el-icon-refresh-right"></i>重置
            </span>
          </div>
        </div>
        <div class="list">
          <dsf-virtual-scroll scroll-x>
            <div
              class="item"
              v-for="(item, index) in value"
              :label="item.id"
              :key="item.id"
            >
              {{ index + 1 }}. {{ item.name }}
              <i
                class="iconfont icon-guanbi2"
                :title="item.isInput ? '自定义数据' : ''"
                @click="deleteFn(item, index)"
                :class="{ isInput: item.isInput }"
              ></i>
            </div>
          </dsf-virtual-scroll>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <dsf-button @click="closeFn" type="plain"> 取消 </dsf-button>
      <dsf-button @click="sureFn"> 确定 </dsf-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "chooseDialog",
  props: {
    resourceId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      visible: false, // 是否显示弹窗
      loading: true, //是否正在请求
      data: [], //可选数据
      value: [], //已选数据
      inputValue: "", //附加文本框
      keyWord: "", //搜索框里的值
      checkConfig: {
        isIndeterminate: false, //半选
        checkAll: false,
        constChoose: [],
        choosedL: 0,
      },
      parent: {},
      maxLength: null,
      noConst: false,
      pagination: {
        pageSize: 10,
        pageNum: 1,
        noData: false,
      },
    };
  },
  watch:{
    keyWord(n,o){
      if(n!=o){
        this.loading = true;
        this.searchFn();
      }
    }
  },
  created(){
    this.searchFn = _.debounce(() =>{
      this.chooseFn();
      this.openFn();
    },300)
  },
  methods: {
    openFn(item) {
      this.loading = true;
      this.noConst = false;
      this.pagination.pageSize = 10;
      this.pagination.pageNum = 1;
      this.pagination.noData = false;
      this.data = [];
      if(item){
        this.keyWord = "";
        this.visible = true;
        this.parent = item;
        this.setMaxLength();
        this.checkConfig.constChoose = [];
        this.checkConfig.checkAll = false;
        this.checkConfig.isIndeterminate = false;
        this.value = [];
        this.getData();
      }else{
        this.getDataConst();
      }
    },
    setMaxLength() {
      let type = this.parent.operator;
      this.maxLength = null;
      switch (type) {
      case "eq":
      case "noteq":
      case "lt":
      case "gt":
      case "lteq":
      case "gteq":
        this.maxLength = 1;
        break;
      // case "in":
      case "between":
      case "gtlt":
      // case "notin":
        this.maxLength = 2;
        break;
      }
    },
    getData() {
      let defaultChoosed = [];
      let value = [];
      if (this.parent.value) {
        let v1 = this.parent.value;
        if (this.maxLength == 2 && this.parent.value2) {
          v1 += " " + this.parent.value2;
        }
        defaultChoosed = v1.split(" ");
        _.forEach(defaultChoosed, (d) => {
          if (d !== "") {
            value.push({
              name: d,
              index: dsf.uuid(),
              isInput: true,
              id: dsf.uuid(),
            });
          }
        });
      }
      this.value = value;

      if (this.parent.code) {
        // 请求常量
        this.getDataConst();
      } else {
        // 派生指标，只有自定义
        this.data = [];
        this.noConst = true;
        this.loading = false;
      }
    },
    getDataConst() {
      // 请求常量
      let code = this.parent.code.split(".");
      let params = {
        adHocQueryColumn: JSON.stringify({
          tableName: this.parent.realTableName || code[0],
          fieldName: code[1],
        }),
        resourceId: this.resourceId || dsf.url.queryString("resourceId"),
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        filter: this.keyWord
      };
      let defaultChoosed = _.map(this.value, (obj) => {
        return obj.name;
      });

      this.$http
        .post("/adHoc/constants", params, true)
        .done((res) => {
          if (res?.success) {
            let data = [];
            _.forEach(res.data, (item, index) => {
              if (item) {
                let obj = {
                  index:
                    this.pagination.pageSize * (this.pagination.pageNum - 1) +
                    index,
                  name: item,
                  choosed: false,
                  id: dsf.uuid(),
                };
                let dI = defaultChoosed.indexOf(item.toString());
                if (dI > -1) {
                  obj.choosed = true;
                  this.value[dI].index = obj.index;
                  this.value[dI].isInput = false;
                }
                data.push(obj);
              }
            });
            if(data.length && this.pagination.pageNum>1 && this.checkConfig.checkAll){
              this.checkConfig.checkAll = false;
              this.checkConfig.isIndeterminate = true;
            }
            if (!data.length || data.length < this.pagination.pageSize) {
              this.pagination.noData = true;
            }
            this.data = this.data.concat(data);
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((res) => {
          dsf.layer.message(res.message, false);
        })
        .always(() => {
          this.loading = false;
        });
    },
    checkAll(state) {
      // 点击了全选
      if (state) {
        this.checkConfig.constChoose = _.map(this.data, (item, index) => {
          return index;
        });
      } else {
        this.checkConfig.constChoose = [];
      }
      this.checkConfig.isIndeterminate = false;
    },
    changeState() {
      // 手动切换全选和半选状态
      let checkedCount = this.checkConfig.constChoose.length;
      this.checkConfig.checkAll =
        checkedCount + this.checkConfig.choosedL === this.data.length;
      this.checkConfig.isIndeterminate =
        checkedCount > 0 &&
        checkedCount < this.data.length - this.checkConfig.choosedL;
    },
    chooseFn() {
      // 选择到右边去
      if (this.inputValue) {
        let values = this.inputValue.split(/[/\t,/\n,-\s]/);
        _.forEach(values, (v) => {
          if (v) {
            this.value.push({
              name: v,
              index: dsf.uuid(),
              isInput: true,
            });
          }
        });
        this.inputValue = "";
      }
      _.forEach(this.checkConfig.constChoose, (index) => {
        let item = this.data[index];
        if (!item.choosed) {
          item.choosed = true;
          this.checkConfig.choosedL++;
          this.value.push(item);
        }
      });
      this.checkConfig.constChoose = [];
      this.checkConfig.checkAll = false;
      this.checkConfig.isIndeterminate = false;
    },
    deleteFn(item, index) {
      // 删除
      if (!item.isInput) {
        let i = item.index;
        this.data[i].choosed = false;
        this.checkConfig.choosedL--;
      }
      dsf.array.removeAt(this.value, index);
      this.changeState();
    },
    resetFn() {
      // 清空
      _.forEach(this.value, (item) => {
        if (!item.isInput) {
          let i = item.index;
          this.data[i].choosed = false;
        }
      });
      this.value = [];
      this.checkConfig.choosedL = 0;
      this.changeState();
    },
    sureFn() {
      // 确定
      let values = _.map(this.value, (item) => {
        return item.name;
      });
      if (!values?.length) {
        dsf.layer.message("请选择数据", false);
        return;
      }
      if (this.maxLength && values.length > this.maxLength) {
        dsf.layer.message(
          "已超出选择数量上限【" + this.maxLength + "】",
          false
        );
      } else {
        if (this.maxLength == 2) {
          this.parent.value = values[0];
          if (values[1]) {
            this.parent.value2 = values[1];
          }
        } else {
          this.parent.value = values.join(" ");
        }
        this.closeFn();
      }
    },
    closeFn() {
      // 关闭弹窗
      this.visible = false;
    },
    paginationScroll(e) {
      let target = e.target;
      if (
        target.scrollHeight - target.clientHeight - target.scrollTop < 20 &&
        !this.loading &&
        !this.pagination.noData
      ) {
        this.paginationLoad();
      }
    },
    paginationLoad() {
      this.loading = true;
      this.pagination.pageNum++;
      this.getDataConst();
    },
  },
};
</script>
